// extracted by mini-css-extract-plugin
export default {"buttonSpinner":"ButtonSpinner_buttonSpinner__l0a4U","spin":"ButtonSpinner_spin__8H3Dp"};